<template>
  <div class="home">
    <img class="title fadeIn" src="../assets/title.png" alt="老师好">
    <a class="btn" v-link="{ name: 'road' }">
      <img src="../assets/btn_bless.png" alt="送上祝福" class="btn-bless">
    </a>
  </div>
</template>

<script>
  module.exports = {
    data: function () {
      return {
        type: true,
        showFadeIn:false
      }
    },
    mounted: function () {
    }
  }
</script>

<style scoped>
  .home {
    width: 100%;
    height: 100%;
    background: url("../assets/p1.jpg") 0 0/100% 100% no-repeat;
  }

  .main img {
    display: block;
  }

  .title {
    width: 4.49rem;
    height: 4.85rem;
    margin: 10% auto;
    display: block;
  }

  .btn {
    position: absolute;
    width: 3.46rem;
    height: 1.07rem;
    bottom: 10%;
    left: 50%;
    margin-left: -1.73rem;
  }

  @media screen  and (max-height: 600px) {
    .title {
      margin: 4% auto;
    }
  }

  @media screen and (width: 320px) and (max-height: 460px) {
    .title {
      margin: 4% auto;
    }
  }

  @media screen and (width: 360px) and (max-height: 540px) {
    .title {
      margin: 4% auto;
    }
  }
</style>



// WEBPACK FOOTER //
// Home.vue?21bff070